import React from "react";
import trans, { isRTL } from "../../utils";
import Close from "../Helpers/CloseBtn/Close";
import Button from "../Helpers/Button/Button";
import { toast } from "react-toastify";
import { useCancelRequestMutation } from "../../Redux/service/Requests/Request";
import { Modal } from "react-bootstrap";

export default function RequestCancelPopup({
	reqId,
	refetch,
	setCancelRequest,
}) {
	console.log("reqIdpopup", reqId);

	const [cancelRequest] = useCancelRequestMutation();

	const handleCancelRequest = async (id) => {
		try {
			await cancelRequest(id).unwrap();
			setCancelRequest(null);
			toast.success(trans("Service request cancelled successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			refetch();
		} catch (error) {
			toast.error(trans("Failed to cancel request"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	return (
		<>
			<Modal show={!!reqId} centered dir={!isRTL ? "ltr" : "rtl"}>
				<Modal.Header>
					<div className="flex-between w-100">
						<Modal.Title>{trans("Cancel")}</Modal.Title>
						<Close
							style="close-32 close"
							img="Close"
							close={() => setCancelRequest(null)}
						/>
					</div>
				</Modal.Header>
				<Modal.Body>
					{trans("Are you sure you want to cancel this request")}
				</Modal.Body>
				<Modal.Footer>
					<Button
						text={trans("Cancel Requset")}
						onClick={() => handleCancelRequest(reqId)}
						danger={true}
					/>
				</Modal.Footer>
			</Modal>
		</>
	);
}
